import NeedHelp from 'core/components/NeedHelp';
import PageBanner from 'core/components/PageBanner/index';
import ServiceDescription from 'core/components/ServiceDescription';
import TableSkeleton from 'core/components/skeleton';
import { TableWithIntervalPrices, TableWithUnits } from 'core/components/Table';
import { SewingModel } from 'features/sewing/data/models/SewingModel';
import { AbstractSewingRemoteDataSource } from 'features/sewing/data/remote/Abstract_sewing_remote_data_source';
import { SewingRemoteDataSource } from 'features/sewing/data/remote/Sewing_remote_data_source';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';
import Images from 'core/data/constants/Images';
import MotionDiv from 'core/components/Motion';

export const Sewing = () => {
  const { t } = useTranslation();
  const [ceremonyDress, setCeremonyDress] = useState<SewingModel[]>([]);
  const [curtains, setCurtains] = useState<SewingModel[]>([]);
  const [jackets, setJackets] = useState<SewingModel[]>([]);
  const [jeans, setJeans] = useState<SewingModel[]>([]);
  const [knitwearBlousesShirtsPolo, setKnitwearBlousesShirtsPolo] = useState<SewingModel[]>([]);
  const [linings, setLinings] = useState<SewingModel[]>([]);
  const [menCoats, setMenCoats] = useState<SewingModel[]>([]);
  const [menPants, setMenPants] = useState<SewingModel[]>([]);
  const [menShirts, setMenShirts] = useState<SewingModel[]>([]);
  const [skirts, setSkirts] = useState<SewingModel[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const sewingRemoteDataSource: AbstractSewingRemoteDataSource = new SewingRemoteDataSource();
      try {
        const [
          resCeremonyDress,
          resCurtains,
          resJackets,
          resJeans,
          resKnitwearBlousesShirtsPolo,
          resLinings,
          resMenCoats,
          resMenPants,
          resMenShirts,
          resSkirts,
        ] = await Promise.all([
          sewingRemoteDataSource.getSewingCeremonyDressData(),
          sewingRemoteDataSource.getSewingCurtainsData(),
          sewingRemoteDataSource.getSewingJacketsData(),
          sewingRemoteDataSource.getSewingJeansData(),
          sewingRemoteDataSource.getSewingKnitwearBlousesShirtsPoloData(),
          sewingRemoteDataSource.getSewingLiningsData(),
          sewingRemoteDataSource.getSewingMenCoatsData(),
          sewingRemoteDataSource.getSewingMenPantsData(),
          sewingRemoteDataSource.getSewingMenShirtsData(),
          sewingRemoteDataSource.getSewingSkirtsData(),
        ]);

        setCeremonyDress(resCeremonyDress.success ? resCeremonyDress.data : []);
        setCurtains(resCurtains.success ? resCurtains.data : []);
        setJackets(resJackets.success ? resJackets.data : []);
        setJeans(resJeans.success ? resJeans.data : []);
        setKnitwearBlousesShirtsPolo(resKnitwearBlousesShirtsPolo.success ? resKnitwearBlousesShirtsPolo.data : []);
        setLinings(resLinings.success ? resLinings.data : []);
        setMenCoats(resMenCoats.success ? resMenCoats.data : []);
        setMenPants(resMenPants.success ? resMenPants.data : []);
        setMenShirts(resMenShirts.success ? resMenShirts.data : []);
        setSkirts(resSkirts.success ? resSkirts.data : []);
      } catch (error) {
        //console.error('API error:', error);
      } finally {
      }
    };

    fetchData();
  }, []);

  return (
    <div className="mainSewing pageBody">
      <PageBanner
        imagePath={Images.SewingBannerImage}
        title={t('default_sewing')}
      />
      <div className="content">
        <MotionDiv className="contentDescription" viewport={{ amount: 0 }} initial={{ opacity: 0, x: -40 }}>
          <ServiceDescription title="default_sewing" description="sewing_description" />
          <NeedHelp />
        </MotionDiv>

        <div className="table">
          <div id="sewingTableSection">
            <MotionDiv viewport={{ once: true, amount: 0 }}>
              <h1>{t('sewing_page_men_coats')}</h1>
              {menCoats.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={menCoats} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_men_pants')}</h1>
              {menPants.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={menPants} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_men_shirts')}</h1>
              {menShirts.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={menShirts} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_jackets')}</h1>
              {jackets.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={jackets} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_curtains')}</h1>
              {curtains.length ? (
                <TableWithUnits columnNames={[t('default_article'), t('default_price')]} data={curtains} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_jeans')}</h1>
              {jeans.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={jeans} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_skirts')}</h1>
              {skirts.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={skirts} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_ceremony_dress')}</h1>
              {ceremonyDress.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={ceremonyDress} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_linings')}</h1>
              {linings.length ? (
                <TableWithIntervalPrices columnNames={[t('default_article'), t('default_price')]} data={linings} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

            <MotionDiv>
              <h1>{t('sewing_page_knitwear_blouses_shirts_polo')}</h1>
              {knitwearBlousesShirtsPolo.length ? (
                <TableWithIntervalPrices
                  columnNames={[t('default_article'), t('default_price')]}
                  data={knitwearBlousesShirtsPolo}
                />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}
            </MotionDiv>

          </div>
        </div>
      </div>
      <div className='footerSeperator'>
      </div>
    </div>
  );
};

export default Sewing;
